import Dexie, { Table } from 'dexie';

/**
 * Interface pour les blobs de photos stockés
 */
export interface PhotoBlobRecord {
	photoId: string;        // UUID de la photo (clé primaire)
	rapportId: number;      // ID du rapport (pour nettoyage en cascade)
	base64: string;         // Image full-size en base64 (compatibilité iOS)
	createdAt: Date;        // Date de création
	lastAccessedAt: Date;   // Date du dernier accès (pour LRU cleanup)
}

/**
 * Base de données dédiée aux blobs de photos
 * 
 * Séparée de la DB principale pour :
 * - Éviter la contention des locks IndexedDB
 * - Isoler les opérations lourdes (92+ MB de blobs)
 * - Faciliter le nettoyage et la gestion du quota
 * - Améliorer les performances des transactions métier
 * 
 * Cette DB fonctionne de manière complètement indépendante de atlasDB.
 */
export class PhotoDB extends Dexie {
	photo_blobs!: Table<PhotoBlobRecord, string>;

	constructor() {
		super('atlasPhotosDB'); // Nom différent de la DB principale

		// Version 1: Table unique pour les blobs
		this.version(1).stores({
			photo_blobs: 'photoId, rapportId, createdAt, lastAccessedAt',
		});
	}
}

// Instance singleton de la DB photos
export const photoDB = new PhotoDB();
